// extracted by mini-css-extract-plugin
module.exports = {"ErrorList":"styles_ErrorList__W11Of"};